import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { Navigate } from "react-router-dom";

/** Predates the unified hub and was never linked from anywhere; every vendor it
 * listed has a catalog entry, so bookmarks land on the hub. */
export const integrationsRoutes: PermissionedRouteObject[] = [
  { index: true, element: <Navigate replace to="../settings/integrations" /> },
];
